import { render, staticRenderFns } from "./UploadInvestorDocuments.vue?vue&type=template&id=46ec3fca&"
import script from "./UploadInvestorDocuments.vue?vue&type=script&lang=js&"
export * from "./UploadInvestorDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports